import {
  HELP_CENTER_ARTICLE_PATH,
  HELP_CENTER_CATEGORY_PATH,
  HELP_CENTER_PATH,
} from "@/features/helpCenter/configs/helpCenterPaths.config";
import type { RouteConfig } from "@/router/types";
import { lazyWithRetry } from "@/shared/utils/lazyWithRetry";

const HelpCenterLayout = lazyWithRetry(() => import("@/features/helpCenter/components/layout/HelpCenterLayout"));
const HelpCenterHomePage = lazyWithRetry(() => import("@/features/helpCenter/pages/HelpCenterHomePage"));
const HelpCenterCategoryPage = lazyWithRetry(() => import("@/features/helpCenter/pages/HelpCenterCategoryPage"));
const HelpCenterArticlePage = lazyWithRetry(() => import("@/features/helpCenter/pages/HelpCenterArticlePage"));

const stripParent = (absolutePath: string): string => absolutePath.slice(HELP_CENTER_PATH.length + 1);

// Les pages enfants sont rendues dans le layout du parent, qui porte déjà
// les guards et le MainLayout.
const helpCenterRoutes: RouteConfig[] = [
  {
    path: HELP_CENTER_PATH,
    element: <HelpCenterLayout />,
    isProtected: true,
    useMainLayout: true,
    mainBackground: "muted",
    children: [
      {
        index: true,
        element: <HelpCenterHomePage />,
        isProtected: false,
        useMainLayout: false,
      },
      {
        path: stripParent(HELP_CENTER_CATEGORY_PATH),
        element: <HelpCenterCategoryPage />,
        isProtected: false,
        useMainLayout: false,
      },
      {
        path: stripParent(HELP_CENTER_ARTICLE_PATH),
        element: <HelpCenterArticlePage />,
        isProtected: false,
        useMainLayout: false,
      },
    ],
  },
];

export default helpCenterRoutes;
